import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Container, Grid } from "@mantine/core";
import { Link } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table"; // Import MantineReactTable
import "../Leave/location.css";
import "./leaveorgin.css";
import Swal from "sweetalert2";
import {
  GetWorkingType,
  HEADERS,
  DeleteWorkingType,
  getOrgId,
} from "../../api";
import axios from "axios";

export default function WorkingDays() {
  const [working_day_type, setworkingType] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      const OrgID = getOrgId();

      try {
        const requestData = { org_id: OrgID };
        const response = await axios.post(GetWorkingType, requestData, {
          headers: HEADERS,
        });
        // $&

        if (response.data.response_code === "0000") {
          setworkingType(response.data.data); // Correctly accessing `data`
        } else {
          console.error(
            "Error fetching working types. Please try again later."
          );
        }
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async (WorkingID) => {
    try {
      const confirmDelete = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this working days",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });

      if (confirmDelete.isConfirmed) {
        const response = await axios.post(
          DeleteWorkingType,
          { working_id: WorkingID },
          { headers: HEADERS }
        );

        if (response.data.response_code === "0000") {
          Swal.fire({
            title: "Deleted!",
            text: "Working day type has been deleted.",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-custom-confirm-btn",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Failed!",
            text: "Failed to delete the Working day type. Please try again later.",
            icon: "error",
            customClass: {
              confirmButton: "swal-custom-confirm-btn",
            },
          });
          console.error(
            "Error deleting Working day type. Please try again later."
          );
        }
      }
    } catch (error) {
      console.error(
        "An error occurred while deleting Working day type:",
        error
      );
    }
  };

  const tableData =
    working_day_type?.map((working_type) => ({
      working_name: working_type.working_name,
      hours_per_day: working_type.hours_per_day,
      monday: working_type.monday,
      tuesday: working_type.tuesday,
      wednesday: working_type.wednesday,
      thursday: working_type.thursday,
      friday: working_type.friday,
      saturday: working_type.saturday,
      sunday: working_type.sunday,
      working_id: working_type.working_id,
      edit: (
        <Link
          to={`/leave-page/working-days/edit-working-days?working_id=${working_type.working_id}&working_name=${working_type.working_name}&hours_per_day=${working_type.hours_per_day}&monday=${working_type.monday}&tuesday=${working_type.tuesday}&wednesday=${working_type.wednesday}&thursday=${working_type.thursday}&friday=${working_type.friday}&saturday=${working_type.saturday}&sunday=${working_type.sunday}`}
        >
          <FontAwesomeIcon icon={faEdit} style={{ cursor: "pointer" }} />
        </Link>
      ),
      delete: (
        <FontAwesomeIcon
          style={{ cursor: "pointer" }}
          icon={faTrash}
          onClick={() => handleDelete(working_type.working_id)}
        />
      ),
    })) || []; // Ensure `tableData` is an empty array if `working_day_type` is undefined

  const tableColumns = [
    {
      accessorKey: "working_name",
      header: "Working Day Type",
    },
    {
      accessorKey: "hours_per_day",
      header: "Hours Per Day",
    },
    {
      accessorKey: "edit",
      header: "Edit",
    },
    {
      accessorKey: "delete",
      header: "Delete",
    },
  ];

  const paginatedData = tableData.slice(page * pageSize, (page + 1) * pageSize);
  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const handlePageChange = (newPage) => setPage(newPage);

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  return (
    <div className="">
      <span className="breadcrumb d-flex gap-2">
        <Link className="previou-link text-decoration-none" to="/leave-page">
          Leave Setting
        </Link>
        <span>/</span>
        <span className="current-link ">Working Days</span>
      </span>

      <div className="heading-section">
        <span className="title">Working Days</span>
      </div>
      <Link
        to="/leave-page/working-days/add-working-days"
        className="text-decoration-none"
      >
        <div className="d-flex mt-1">
          <button className="ms-auto button add-button">
            Add Working Day Type
          </button>
        </div>
      </Link>

      <div className="tab mt-3">
        <MantineReactTable
          columns={tableColumns}
          data={paginatedData}
          enablePagination={false}
          enableColumnFilters={true}
          enableSorting={true}
          enableFullScreenToggle={false}
          enableColumnOrdering={true}
          enableGlobalFilter={true}
          enableRowSelection={false}
          mantineTableBodyCellProps={{
            style: {
              backgroundColor: "#C8E3EC60",
              color: "#505050",
              border: "0.5px solid #fff",
              padding: "10px",
            },
          }}
          mantineTableHeadCellProps={{
            style: {
              backgroundColor: "#2d7d9f",
              fontSize: "14px",
              fontWeight: 500,
              color: "#fff",
              border: "1px solid #fff",
            },
          }}
          mantineTableBodyRowProps={(row) => ({
            style: {
              backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
            },
          })}
        />
        <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontSize: "14px" }}>Items per page:</span>
            <select
              className="form-select"
              style={{ width: "110px" }}
              value={pageSize}
              onChange={(e) => handlePageSizeChange(parseInt(e.target.value))}
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
              <option value={100}>100 rows</option>
            </select>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <span style={{ fontSize: "14px" }}>
              {totalRows === 0
                ? "Showing 0 to 0 of 0 entries"
                : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-3">
            <button
              className="previous-button"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 0}
            >
              Previous
            </button>
            <button
              className="add-button text-center justify-content-center"
              style={{ width: "100px" }}
              onClick={() => handlePageChange(page + 1)}
              disabled={(page + 1) * pageSize >= tableData.length}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
